import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ClientDashboardLegacy from './ClientDashboardLegacy';
import ClientNewViews from './ClientNewViews';

/**
 * ClientDashboard - Main router for client context
 *
 * Routes:
 *   - /client/* -> New views (Home, Progress, Goals, Documents, Profile, Settings)
 *   - /client/legacy/* -> Legacy dashboard (preserved for fallback)
 *
 * The legacy view is always available via the "Switch to Legacy View" banner.
 * Users can toggle between new and legacy views while we validate the new experience.
 */
const ClientDashboard: React.FC = () => {
  return (
    <Routes>
      {/* Legacy routes - preserved for fallback/comparison */}
      <Route path="/legacy/*" element={<ClientDashboardLegacy />} />

      {/* New views - default experience */}
      <Route path="/*" element={<ClientNewViews />} />
    </Routes>
  );
};

export default ClientDashboard;
